import type { IconNode } from '../types';

/**
 * @name toilet-roll
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8ZWxsaXBzZSBjeD0iMTAiIGN5PSI4IiByeD0iMyIgcnk9IjIiIC8+CiAgPGVsbGlwc2UgY3g9IjEwIiBjeT0iOCIgcng9IjciIHJ5PSI2IiAvPgogIDxwYXRoIGQ9Ik0zIDh2OGMwIDMuMyAzLjEgNiA3IDZzNy0yLjcgNy02VjhjMCAyLjIgMi4yIDQgNSA0djhjLTIuOCAwLTUtMS44LTUtNCIgLz4KICA8cGF0aCBkPSJNMTAgMTR2MiIgLz4KICA8cGF0aCBkPSJNMTAgMjB2MiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/toilet-roll
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const toiletRoll: IconNode = [
  ['ellipse', { cx: '10', cy: '8', rx: '3', ry: '2', key: '3e3flj' }],
  ['ellipse', { cx: '10', cy: '8', rx: '7', ry: '6', key: '1b2s8q' }],
  [
    'path',
    { d: 'M3 8v8c0 3.3 3.1 6 7 6s7-2.7 7-6V8c0 2.2 2.2 4 5 4v8c-2.8 0-5-1.8-5-4', key: 'kup9bp' },
  ],
  ['path', { d: 'M10 14v2', key: 'uk47kn' }],
  ['path', { d: 'M10 20v2', key: '1n8e1g' }],
];

export default toiletRoll;
